import React from 'react';
import styled from 'styled-components';
import { Logo } from '.';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { useClient } from '@context/presentation';
import { UNAVAILABLE_CS_FIRM } from '@constants';

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    justify-content: space-between;
    background: linear-gradient(#091D27, #002939);
    background-size: cover;
    margin: 0;
    z-index: 1;
    color: rgb(255, 255, 255);
    height: 50px;
    position: relative;
    width: 100%;
    top: 0;
    overflow-x: hidden;
`;

const HeaderStyle = styled.h2`
    font-family: ${props => props.theme.serif};
    font-size: ${props => props.desktop ? props.theme.desktopHeaderSize : props.theme.mobileHeaderSize};
    line-height: 27.24px;
    font-weight: normal;
    color: #fff;
    margin: 0;
    width: 100%;
    position: relative;
    padding: 0px 20px 0px 20px;
`;

export const SlideHeader = () => {
    const { t } = useTranslation();
    const { data, desktop, viewport } = useSlideData();
    const { name } = data;
    const { firm, firmShortName } = useClient();
    // Might flesh this out to be a regex match
    const translationKey = name.split(' ').join('_').toLowerCase();
    const firmNotAvailable = firm === UNAVAILABLE_CS_FIRM;
    const firmToRender = firmNotAvailable ? '(Insert Firm Here)' : firmShortName;
    const weCanHelpHeader = t(`${translationKey}.title_1`) + firmToRender + t(`${translationKey}.title_2`);
    const desktopHeader = t(`${translationKey}.title`);
    const mobileHeader = t(`${translationKey}.short_title`);

    const title = !desktop ? mobileHeader : translationKey === 'we_can_help' ? weCanHelpHeader : desktopHeader;

    return (
        <HeaderContainer>
            <HeaderStyle desktop={desktop}>
                {title}
            </HeaderStyle>
            { !firmNotAvailable && <Logo viewport={viewport} desktop={desktop} /> }
        </HeaderContainer>
    );
};

export default SlideHeader;